import { request } from '@/utils/ajax'

// export function inviteBuyer(residentialUnitId, email) {
//     return request(`api/residential-unit/${residentialUnitId}/invite-buyer`, {
//         method: "POST",
//         json: true,
//         body: { email }
//     }).then(x => x.json());
// }

export function getInvitationInfo(token) {
    
    return request(`api/user-invitation?token=${encodeURIComponent(token)}`).then(x => x.json());
}


export function acceptInvite(token, newUserInfo) {
    return request(`api/user-invitation/accept`, {
        method: "POST",
        json: true,
        body: {
            token,
            userRegistrationInfo: newUserInfo
        }
    }).then(x => x.json());
}